import { createRouter, createWebHistory } from 'vue-router'
const AudienceView = () => import('./views/AudienceView.vue')
const JoinView = () => import('./views/JoinView.vue')
const ModeratorView = () => import('./views/ModeratorView.vue')
const WallView = () => import('./views/WallView.vue')
const SpeakerView = () => import('./views/SpeakerView.vue')
const AdminView = () => import('./views/AdminView.vue')
const LegalView = () => import('./views/LegalView.vue')
const PrivacyView = () => import('./views/PrivacyView.vue')

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/join' },
    { path: '/join', component: JoinView, meta: { publicSurface: true, title: 'Join event' } },
    { path: '/legal/acceptable-use', component: LegalView, meta: { publicSurface: true, title: 'Acceptable use' } },
    { path: '/legal/privacy', component: PrivacyView, meta: { publicSurface: true, title: 'Tractus Gather privacy policy' } },
    { path: '/s/:sessionCode', component: AudienceView, meta: { publicSurface: true, eventThemed: true, title: 'Audience' } },
    { path: '/moderate', component: ModeratorView, meta: { eventThemed: true, title: 'Moderate' } },
    { path: '/wall', component: WallView, meta: { displaySurface: true, eventThemed: true, title: 'Question wall' } },
    { path: '/stage', component: WallView, meta: { displaySurface: true, eventThemed: true, title: 'Stage display' } },
    { path: '/speaker', component: SpeakerView, meta: { publicSurface: true, eventThemed: true, title: 'Speaker queue' } },
    { path: '/admin', component: AdminView, meta: { title: 'Administration', adminSurface: true } },
    { path: '/admin/shows', component: AdminView, meta: { title: 'Shows', adminSurface: true, adminSection: 'shows' } },
    { path: '/admin/capacity', redirect: '/admin' },
    { path: '/admin/sessions/:sessionId/usage', redirect: to => `/admin/sessions/${encodeURIComponent(to.params.sessionId)}/details` },
    { path: '/admin/sessions/:sessionId/:section(details|embed|branding|access|integrations|retention)?', component: AdminView, meta: { title: 'Session administration', adminSurface: true } },
    { path: '/:pathMatch(.*)*', redirect: '/join' },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

export default router
